// console.info("axios call");

import { userStore, types } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";

export default {
    async list(): Promise<types.ResCategoryList> {
        const res = {} as types.ResCategoryList;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/category/list", { withCredentials: false });

            return response.data;
        } catch (error) {
            console.info(error);
        }
        return res;
    },
};
